import { OnInit, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export abstract class Field implements OnInit {
    public form: FormGroup;

    constructor(private readonly viewContainerRef: ViewContainerRef) {}

    public ngOnInit(): void {
        for (const element of (this.viewContainerRef.parentInjector as any).view.oldValues) {
            if (element instanceof FormGroup) {
                this.form = element;
            }
        }
    }

    protected addFormValidator(name: string, validators: Validators, value: string = '') {
        this.form.addControl(name, new FormControl(value, validators));
    }
}
